import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import { CustomFileUploaderComponent } from './CustomFileUploader';
import documentationActions from 'actions/documentationActions';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
    };
};

const mapDispatchToProps = dispatch => ({
    formActions: bindActionCreators(formActions, dispatch),
    documentationActions: bindActionCreators(documentationActions, dispatch),
});

export const CustomFileUploader = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    CustomFileUploaderComponent
);
